import { useEffect, useState } from "react";

let AdvancedMarkerElementInstance = null; // Store the imported AdvancedMarkerElement globally
let PinElementInstance = null; // Store PinElement for future customization

const AdvancedMarker = ({ map, position, title, content, draggable, onDragEnd }) => {
    const [marker, setMarker] = useState(null);

    useEffect(() => {
        if (!map || !window.google || !position) return;

        const loadMarker = async () => {
            try {
                // Import AdvancedMarkerElement & PinElement once
                if (!AdvancedMarkerElementInstance || !PinElementInstance) {
                    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
                    AdvancedMarkerElementInstance = AdvancedMarkerElement;
                    PinElementInstance = PinElement;
                }

                // Remove existing marker before creating a new one
                if (marker) {
                    marker.map = null;
                }

                const newMarker = new AdvancedMarkerElementInstance({
                    map,
                    position,
                    title,
                    gmpDraggable: draggable,
                    content: content,
                });

                // Handle Drag Event
                if (draggable) {
                    newMarker.addListener("dragend", (event) => {
                        if (onDragEnd) {
                            onDragEnd(event);
                        }
                    });
                }

                setMarker(newMarker);
            } catch (error) {
                console.error("Failed to load AdvancedMarkerElement:", error);
            }
        };

        loadMarker();

        return () => {
            if (marker) marker.setMap(null);
        };
    }, [map, position, content, draggable]);

    return null; // No visible output, just renders a marker on the map
};

export default AdvancedMarker;
